import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import CabinsFullWidth from "../components/cabinsFullWidth"
import LocationComponent from "../components/location"

const Location = () => {
  return (
    <Layout>
      <SEO
        title="Location"
        description="Find Gold Coast Retreat at 1338 Chesterman Beach Road, Tofino, BC — map and directions on Vancouver Island's west coast."
      />
      <LocationComponent />
      <CabinsFullWidth/>
    </Layout>
  )
}

export default Location
